import type { FireflyRuntime, ModuleRegisterFunction } from "@squide/firefly";

export const registerActionItems: ModuleRegisterFunction<FireflyRuntime> = async runtime => {
    if (runtime.isMswEnabled) {
        const { actionItemsRequestHandler } = await import("./mocks/actionItemsRequestHandler.ts");

        runtime.registerRequestHandlers([actionItemsRequestHandler]);
    }
};
